// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-BirthdayField-styles--birthday--N40ZF {
  width: 100%;
}

@media screen and (min-width: 768px) {

.src-components-BirthdayField-styles--month--CeAns {
    width: 66%;
}
  }

.src-components-BirthdayField-styles--birthday--N40ZF > * {
  flex-basis: auto !important;
  width: 32%;
}

@media screen and (min-width: 768px) {

.src-components-BirthdayField-styles--birthday--N40ZF > * {
    width: 33%;
}
  }

`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/BirthdayField/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,WAAW;AACb;;AAGE;;AADF;IAEI,UAAU;AAEd;EADE;;AAGF;EACE,2BAA2B;EAC3B,UAAU;AAKZ;;AAHE;;AAJF;IAKI,UAAU;AAEd;EADE","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.birthday {\n  width: 100%;\n}\n\n.month {\n  @media (--desktop) {\n    width: 66%;\n  }\n}\n\n.birthday > * {\n  flex-basis: auto !important;\n  width: 32%;\n\n  @media (--desktop) {\n    width: 33%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"birthday": `src-components-BirthdayField-styles--birthday--N40ZF`,
	"month": `src-components-BirthdayField-styles--month--CeAns`
};
module.exports = ___CSS_LOADER_EXPORT___;
